;(function($, undefined){

    var rnn = window.rnn,
    log = rnn.logging.log,
    userData, getQueue;

    var $notificationsList = $('.notifications-list'),
    $dot = $('.hat .small-profile.small-profile-25px'),
    $counter = $('.notify-count'),
    $title = $('title'),
    titleVal = $title.html(),
    tally = 0,
    current;

    if($notificationsList.length) {
        var $yourNotifications = $notificationsList.find('.your-notifications'),
        $loading = $notificationsList.find('.notificationsLoading'),
        $loadMore = $notificationsList.find('.btn'),
        $empty = $notificationsList.find('.notificationsEmpty'),
        $alertContainer = $('.alertWrapper'),
        source = $('#hdlbars-accounts-notification').html(),
        template = Handlebars.compile(source),
        notificationsDisplayed,
        renderedNotifications,
        lastNotification,
        newLast,
        max20Results;
    }

    function supportsHtml5Storage(){
        if (window.Modernizr) {
            return window.Modernizr.localstorage;
        }
        try {
            return 'localStorage' in window && window['localStorage'] !== null;
        } catch(e) {
            return false;
        }
    }

    function get(callback) {
        if (userData) {
            log('[user.get]', 'Executing callback');
            callback(userData);
        } else {
            log('[user.get]', 'Queueing callback');
            getQueue.push(callback);
        }
    }

    function login(username, password, target) {
        var errorFunction = function (errors) {
            log('[user]', 'User login failed');
            var loginErrorEvent = $.Event('loginError');
            loginErrorEvent.target = target;
            loginErrorEvent.errors = errors;
            $(rnn).trigger(loginErrorEvent);
        };

        var textBox = $(target).parent().find('.replyBox');

        if (textBox.length && $(textBox).val().length <= 0) {
            var errorMessages = $($.el.ul()),
            form = $(event.target);
            errorMessages.append($($.el.ul('Textfield is required.')));
            rnn.modules.alert.show(form.find('.messages'),{
                'message':errorMessages,
                'type':'error'
            });
            return 0;
        } else {
            if (!username || !password) {
                errorFunction("Please fill out all required fields.");
            } else {
                $.ajax({
                    url: rnn.site.loginURL,
                    data: {username: username, password: password, json: true},
                    type: 'post',
                    contentType: 'application/json',
                    success: function (data) {
                        if (data.authenticated) {
                            log('[user]', 'User populated from server');
                            userData = data;
                            clearGetQueue();
                            var loginEvent = $.Event('login');
                            loginEvent.target = target;
                            $(rnn).trigger(loginEvent);
                        } else {
                            errorFunction(data.error);
                        }
                    },
                    error: errorFunction
                });
            }
        }
    }

    function toConsole() {
        window.console && window.console.log && get(function (user) {
            window.console.log(user);
        });
    }

    function clearGetQueue() {
        var callback;

        while (getQueue.length > 0) {
            callback = getQueue.pop();
            log('[user.get]', 'Un-queueing and executing callback');
            callback(userData);
            callback = null;
        }
    }

    // returns user data stored in the user data cookie
    function cookieUserData() {
      var uDetails = Cookies.get("apn_user_data") || "";
      if (uDetails) {
        try { uDetails = JSON.parse(decodeURIComponent(atob(uDetails))) }
        catch (e) { uDetails = {} }
      }
      return uDetails
    }

    function requestUserData() {
        var userAccountURL = rnn.site.userAccountURL,
        userDataURL = rnn.site.userDataURL;

        log('[user]', 'Requesting user data from server...');

        // When the Notification Wrapper Class and footer are both visible, we're probably viewing
        // a proper full page. Fetch notifications for the user, so the
        // notifications module can display them.
        if ($(rnn.site.notificationWrapperClass).length && $('footer').length) {
            // Assuming that the base URL will never have a query string.
            userDataURL += '?notifications=1';
        }

        // Only want to trigger the userstatus request if the current site has a my-account URL set up
        // - currently configured by setting rnn.site.userAccountURL
        if (userAccountURL) {
            $.getJSON(userDataURL, function (responseUserData) {
                log('[user]', 'User data returned from server');
                userData = responseUserData;
                if (userData.authenticated) {
                    log('[user]', 'User populated from server');
                } else {
                    log('[user]', 'User is anonymous');
                }
                clearGetQueue();
            });
        }
    }

    function userDisplayName() {
        var $user = $(".user_display_name");

        if ($user.length > 0) {
            get(function(user) {
                $user.html(user.display_name);
            });
        }
    }

    function storeUserStatus() {
        // Function to store userstatus.badge_number and timestamp in local storage
        // If userstatus.badge_number is different, trigger the custom userstatus_updated event
        current = localStorage.badge_number || 0;
        localStorage.setItem('badge_timestamp', new Date().getTime());
        $.getJSON(rnn.site.userDataURL, function(userstatus){
            localStorage.setItem('badge_number', userstatus.badge_number);
            if(current != localStorage.badge_number)
                $(document).trigger('userstatus-updated');
        });
    }

    function updateUserStatus() {
        // Function to store userstatus in local storage
        // If userstatus already exists in local storage, then reset it every 30s
        if(localStorage.badge_number && localStorage.badge_timestamp) {
            if(new Date().getTime() - localStorage.badge_timestamp >= 30000)
                storeUserStatus();
        } else {
            storeUserStatus();
        }
        setTimeout(updateUserStatus, 5000);
    }

    function renderNotifications(notifications, index, iterate, new_only) {
        // Function to loop through notifications data retrieved from the
        // Notifications API and render out the handlebars template
        var html = '';

        for(index; index<iterate; index++) {
            if(new_only && !notifications[index].is_new) continue;
            html += template(notifications[index]);
        }

        return html;
    }

    function toggleShowMoreNotificationsButton(totalNotifications) {
        // Function to compare notifications currently displayed with the total notifications
        // and toggle display of the Show More Notifications button
        notificationsDisplayed = $notificationsList.find('article.headline-list').length;

        if (notificationsDisplayed < totalNotifications) {
            $loadMore.removeClass('hide').find('#loader').addClass('hide').siblings('span').html('Show More Notifications');
        } else {
            $loadMore.addClass('hide');
        }
    }

    function loadNotifications(type, badge_number) {
        // Function to manage content on the Notifications List page
        $.getJSON(rnn.site.notificationsUrl + '?format=json', function(data){
            var notifications = data;

            $loading.addClass('hide');

            if(notifications.count) {
                $empty.addClass('hide');

                if (type == "load_more") {
                    // "load_more" is triggered when the user clicks the "Show More Notifications" button
                    // Render 20 additional notifications and display them at the end of the list
                    lastNotification = $yourNotifications.find('article.headline-list').length;
                    newLast = lastNotification + 20 > notifications.count ? notifications.count : lastNotification + 20;

                    renderedNotifications = renderNotifications(notifications.results, lastNotification, newLast);
                    $yourNotifications.find('article.headline-list:last-of-type').after(renderedNotifications);

                } else if(type == "load_new") {
                    // "load_new" is triggered when userstatus.badge_number in local storage recieves new data
                    // Render new notifications and prepend them at the start of the list
                    renderedNotifications = renderNotifications(notifications.results, 0, badge_number, true);
                    $yourNotifications.prepend(renderedNotifications);

                } else {
                    // Render the Notifications List with up to 20 notifications
                    max20Results = 20 > notifications.count ? notifications.count : 20;

                    renderedNotifications = renderNotifications(notifications.results, 0, max20Results);
                    $yourNotifications.prepend(renderedNotifications);
                }

                $yourNotifications.find('abbr.pubDate').timeago().end();
                toggleShowMoreNotificationsButton(notifications.count);
                rnn.modules.trackEvents.init();
            } else {
                $empty.removeClass('hide');
            }
        }).fail(function() {
            $alertContainer.html("<div class='alert alert-danger'><button type='button' data-dismiss='alert' aria-hidden='true' class='close'>&times;</button>Unable to access notifications</div>");
        });
    }

    function displayNotificationIndicators(badge_number, calltime) {
        // Function to display indicators when a user recieves new notifications

        if(Number(badge_number)) {
            tally += Number(badge_number);

            if ($notificationsList.length) {
                // While on the Notifications List page, update the counter with a running tally
                $notificationsList.find($counter).html(tally).closest('.notify-new').removeClass('hide');

                if(calltime != "on_load"){
                    $loading.removeClass('hide').find('p').html('Loading new notifications...');
                    loadNotifications("load_new", badge_number);
                }
            } else {
                // While on the RNN Sites and not on the Notifications List page:
                // Add the red dot indicators to a user's profile image/hamburger toggle,
                // update any visible counters and add the count to the window's tab title
                if(rnn.site.network.name === "RNN") {
                    $dot.addClass('notify-dot');
                    $counter.html(badge_number).closest('.notify-new').removeClass('hide');
                    $title.html('(' + badge_number + ') ' + titleVal);
                }
            }
        } else {
            if(!$notificationsList.length && rnn.site.network.name === "RNN") {
                $dot.removeClass('notify-dot');
                $counter.closest('.notify-new').addClass('hide');
                $title.html(titleVal);
            }
        }
    }

    function initialiseNotifications() {
        if ($notificationsList.length) {
            loadNotifications();

            $loadMore.click(function(e) {
                e.preventDefault();
                $loadMore.find('#loader').removeClass('hide').siblings('span').html('Loading more notifications...');
                loadNotifications("load_more");
            });
        }

        if (supportsHtml5Storage()) {
            displayNotificationIndicators(localStorage.badge_number, "on_load");
            $(window)
            .on('storage', function(e) {
                if(e.originalEvent.key == 'userstatus') {
                    displayNotificationIndicators(localStorage.badge_number);
                }
            })
            .on('userstatus-updated', function() {
                displayNotificationIndicators(localStorage.badge_number);
            });
        }
        else {
            (function noLocalStorage() {
                $.getJSON(rnn.site.userDataURL, function(userstatus){
                    displayNotificationIndicators(userstatus.badge_number, "on_load");
                    setTimeout(noLocalStorage, 30000);
                });
            })();
        }
    }

    // Initialise the user
    function initialiseUser() {
        // Initialise getQueue
        getQueue = [];

        // Initialise the user with server data
        requestUserData();

        // Automatic username population
        userDisplayName();

        // Initialise Notifications
        get(function (user) {
            if(user.authenticated) {
                if (supportsHtml5Storage()) {
                    updateUserStatus();
                }
                initialiseNotifications();
            }
            else if (user.norestrict) {
                Cookies.set('norestrict', true);
            }
            else if (Cookies.get('norestrict')) {
                Cookies.remove('norestrict');
            }
        });
    }

    function isSubscriber() {
        var userData = cookieUserData();
        if (Cookies.get('subscribed') || (userData && (userData.subscribed || userData.norestrict))) {
            return true;
        } else {
            return false;
        }
    }

    rnn.modules.register("user", {
        init: initialiseUser,
        get: get,
        toConsole: toConsole,
        login: login,
        cookieData: cookieUserData,
        isSubscriber: isSubscriber
    });

})(jQuery);
